function getRawText(component: React.ReactElement<HTMLElement>): string {
  return elementToString(component).replace(/<\/?[^>]+(>|$)/g, '');
}

function elementToString(
  element:
    React.ReactElement<HTMLElement> | HTMLCollection | string | number | null
): string {
  if (typeof element === 'string') return element;
  if (typeof element === 'number') return element.toString();
  if (element === null) return '';
  element = element as React.ReactElement<HTMLElement>;

  const props = element.props;
  const type = element.type;

  // Handle children
  let children: string;
  if (Array.isArray(props.children)) {
    if (props.children) {
      children = props.children.map(elementToString).join('');
    } else {
      children = '';
    }
  } else if (props.children) {
    children = elementToString(props.children);
  } else {
    children = '';
  }

  // For simple elements
  if (typeof type === 'string') {
    const propStr = Object.entries(props)
      .filter(([key]) => key !== 'children')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');

    return `<${type}${propStr ? ' ' + propStr : ''}>${children}</${type}>`;
  }

  // For functional components
  if (typeof type === 'function') {
    // eslint-disable-next-line
    const typeFunc = type as Function;
    return elementToString(typeFunc(props));
  }
  return children;
}

export { getRawText };
